import { kymw6900Handlers } from "./kymw6900-handlers";
import { kymw6901Handlers } from "./kymw6901-handlers";
import { kymw6902Handlers } from "./kymw6902-handler";

export const kymw69Handlers = [
  ...kymw6900Handlers, ...kymw6901Handlers, ...kymw6902Handlers
]

